import styled from "styled-components/macro";

export const Container = styled.div`
  text-align: left;
  z-index: 1000;

  .inner {
    color: var(--icon-button-fill);
    opacity: var(--icon-button-opacity);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-family: Inter;
    font-weight: 500;

    .save {
      padding-left: 18px;
      display: flex;
      align-items: center;

      svg {
        path {
          fill: var(--grey-0);
        }
      }

      &.saved {
        color: #70d5dd;
      }

      .saved-locally {
        display: flex;
        align-items: center;
        color: var(--icon-button-fill);
        opacity: 0.7;
        cursor: default;
      }
    }

    height: 40px;
    background: none;
    text-align: left;
    padding: 0;
    font-size: 14px;
    line-height: 1;

    .highlighted {
      font-weight: bold;
      margin-left: 5px;
    }
  }
`;
